import { keyCodes, updateAccordionIconsLabels } from '@msc-b2c/shared-utils';

(function () {
  'use strict';

  const selectors = {
    self: 'cmp-contentfragment',
    faq: 'faq-wrapper',
    faqAccordion: 'accordion__cmp',
    faqAccordionQuestion: 'question',
    faqAccordionAnswer: 'answer',
    faqActive: 'active',
    answerOpen: 'open',
  };

  let dataLayerEnabled: boolean;
  let dataLayerName: string;

  class ContentFragmentFAQ {
    private _self!: HTMLElement;

    constructor(self: HTMLElement) {
      if (self) {
        this.init(self);
      }
    }

    private init(self: HTMLElement) {
      this._self = self;
      const faqAsyncContainer = this._self.querySelector('.faqAsyncContainer');
      if (faqAsyncContainer) {
        const faqsData = faqAsyncContainer.getAttribute('data-faqs');
        if (faqsData) {
          const faqs = JSON.parse(faqsData);
          faqs.forEach(
            (faq: {
              dataComponentName: string;
              questionTitle: string;
              titleHeadings: string;
              answerDescription: string;
              iconArrowUpLabel: string;
              iconArrowDownLabel: string;
            }) => {
              const accordionDiv = document.createElement('div');
              accordionDiv.className = 'accordion__cmp';
              accordionDiv.setAttribute('data-cmp-is', 'accordion');
              const questionDiv = document.createElement('div');
              questionDiv.className = 'accordion__cmp-question';
              questionDiv.setAttribute('role', 'button');
              questionDiv.setAttribute('tabindex', '0');
              questionDiv.setAttribute('data-cmp-is', 'cf-accordion');
              questionDiv.setAttribute('data-cmp-is-active', 'false');
              questionDiv.setAttribute('data-close-label', faq.iconArrowUpLabel ?? '');
              questionDiv.setAttribute('data-open-label', faq.iconArrowDownLabel ?? '');
              questionDiv.id = faq.dataComponentName;
              const questionElement = document.createElement(faq.titleHeadings);
              questionElement.className = 'accordion__cmp-title';
              questionElement.textContent = faq.questionTitle;
              const icon = document.createElement('i');
              icon.className = 'icon icon-down';
              icon.setAttribute('aria-hidden', 'false');
              icon.setAttribute('tabindex', '-1');
              icon.setAttribute('title', faq.iconArrowDownLabel ?? '');
              const answerDiv = document.createElement('div');
              answerDiv.className = 'accordion__cmp-answer';
              const answerParagraph = document.createElement('p');
              answerParagraph.innerHTML = faq.answerDescription; // Usato innerHTML per mantenere i tag HTML

              questionDiv.appendChild(questionElement);
              questionDiv.appendChild(icon);
              answerDiv.appendChild(answerParagraph);
              accordionDiv.appendChild(questionDiv);
              accordionDiv.appendChild(answerDiv);
              faqAsyncContainer.appendChild(accordionDiv);
            }
          );
        }
      }
      const faqs = this._self.querySelectorAll(`.${selectors.faqAccordion}`);

      clampFAQToMaxLineNumber(faqs, this._self);
      updateAccordionIconsLabels(false);

      const toggleAccordionItem = (
        faq: Element,
        question: HTMLDivElement,
        answer: HTMLDivElement
      ) => {
        if (faq.classList.contains(`${selectors.faqAccordion}--${selectors.faqActive}`)) {
          const urlWithoutHash = window.location.href.split('#')[0];
          history.replaceState(null, document.title, urlWithoutHash);
          faq.classList.remove(`${selectors.faqAccordion}--${selectors.faqActive}`);
          question.dataset['cmpIsActive'] = 'false';
          question.querySelector('.icon')?.classList.remove('icon-up');
          question.querySelector('.icon')?.classList.add('icon-down');
          answer?.classList.remove(selectors.answerOpen);
          updateIconAriaLableAndTooltip(question, false);
        } else {
          const urlWithoutHash = window.location.href.split('#')[0];
          history.replaceState(null, document.title, urlWithoutHash);
          faq.classList.add(`${selectors.faqAccordion}--${selectors.faqActive}`);
          question.dataset['cmpIsActive'] = 'true';
          question.querySelector('.icon')?.classList.remove('icon-down');
          question.querySelector('.icon')?.classList.add('icon-up');
          answer?.classList.add(selectors.answerOpen);
          updateIconAriaLableAndTooltip(question, true);
        }
      };

      faqs.forEach((faq) => {
        const question = faq.querySelector(
          `.${selectors.faqAccordion}-${selectors.faqAccordionQuestion}`
        ) as HTMLDivElement;
        const answer = faq.querySelector(
          `.${selectors.faqAccordion}-${selectors.faqAccordionAnswer}`
        ) as HTMLDivElement;

        const urlHash = window.location.hash.replace('#', '');
        if (question.id === urlHash) {
          faq.classList.add(`${selectors.faqAccordion}--${selectors.faqActive}`);
          question.dataset['cmpIsActive'] = 'true';
          question.querySelector('.icon')?.classList.remove('icon-down');
          question.querySelector('.icon')?.classList.add('icon-up');
          answer?.classList.add(selectors.answerOpen);
          updateIconAriaLableAndTooltip(question, true);
        }

        question.addEventListener('click', () => {
          toggleAccordionItem(faq, question, answer);
        });
        question.addEventListener('keydown', (event) => {
          if (event.key === keyCodes.ENTER || event.key === keyCodes.SPACE) {
            event.preventDefault();
            toggleAccordionItem(faq, question, answer);
          }
        });
        if (this._self.parentElement?.classList.contains('-ship-phone-numbers')) {
          shipPhoneNumbersTable(answer);
          document.querySelectorAll('p').forEach(function (p) {
            if (p.innerHTML.trim() === '&nbsp;' || p.innerHTML.trim() === '\u00A0') {
              p.style.display = 'none';
            }
          });
        }
      });
    }
  }

  function faqGetShowMoreShowLess(currentFaqContainer: Element | null) {
    const cfParentElement = currentFaqContainer?.parentElement?.parentElement;
    if (!cfParentElement) return;
    // TO DO OPTIMIZATION use class instead - now be specific and select the buttons insile the container
    const showmoreButton = cfParentElement.querySelector(
      ':scope > .button > .cmp-button[id="cf-faq-showmore"]'
    ) as HTMLElement;
    const showlessButton = cfParentElement.querySelector(
      ':scope > .button > .cmp-button[id="cf-faq-showless"]'
    ) as HTMLElement;
    if (showmoreButton && showlessButton) {
      return [showmoreButton, showlessButton];
    }
    return null;
  }

  function clampFAQToMaxLineNumber(elements: NodeList, cfElement: Element) {
    const faqMaxNumberClass = document.querySelector('.faqMaxNumber');
    const maxNumber = parseInt(faqMaxNumberClass?.getAttribute('data-maxfaqnumber') ?? '');
    const faqItemsLenght = elements.length;

    const [showmoreButton, showlessButton] = faqGetShowMoreShowLess(cfElement) ?? [null, null];

    if (!faqItemsLenght || maxNumber >= faqItemsLenght || maxNumber === 0 || isNaN(maxNumber)) {
      if (showmoreButton && showlessButton) {
        showmoreButton.style.display = 'none';
        showlessButton.style.display = 'none';
        return;
      }
      return;
    }

    if (showmoreButton && showlessButton) {
      // initial state
      let hiddenFaqs = hideFaqs(elements, maxNumber);
      showlessButton.style.display = 'none';

      showmoreButton.addEventListener('click', (e: Event) => {
        e.stopImmediatePropagation();
        hiddenFaqs.forEach((node: HTMLElement) => {
          node.style.display = 'inline-flex';
          showlessButton.style.display = 'inline-flex';
          showmoreButton.style.display = 'none';
        });
      });

      showlessButton.addEventListener('click', (e: Event) => {
        e.stopImmediatePropagation();
        hiddenFaqs = hideFaqs(elements, maxNumber);
        showlessButton.style.display = 'none';
        showmoreButton.style.display = 'inline-flex';
        document.body.scrollTo({
          top: document.body.scrollTop + showmoreButton.getBoundingClientRect().top - 100,
          behavior: 'instant',
        });
      });
    }
  }

  // hide faqs based on max number
  function hideFaqs(elements: NodeList, maxNumber: number) {
    const hiddenFaqs = [];
    for (let i = 0; i < maxNumber; i++) {
      const elementPos = elements.length - 1 - i;
      const elementToHide = elements[elementPos] as HTMLElement;
      hiddenFaqs.push(elementToHide);
      elementToHide.style.display = 'none';
    }
    return hiddenFaqs;
  }

  function updateIconAriaLableAndTooltip(question: HTMLElement, isOpen: boolean) {
    // get label atrributes
    const arrowUpLabel = question.getAttribute('data-close-label');
    const arrowDownLabel = question.getAttribute('data-open-label');

    if (arrowUpLabel && arrowDownLabel) {
      const icon = question.querySelector('.icon');
      if (isOpen) {
        icon?.setAttribute('title', arrowUpLabel);
      } else {
        icon?.setAttribute('title', arrowDownLabel);
      }
    }
  }

  function shipPhoneNumbersTable(answer: HTMLElement) {
    const tables = answer.querySelectorAll('table');
    if (tables.length > 0) {
      const newTable = document.createElement('div');
      newTable.className = 'columns-table';

      tables.forEach((table) => {
        const rows = Array.from(table.querySelectorAll('tr'));
        if (rows.length === 0) return;

        const maxColumns = Math.max(...rows.map((row) => row.children.length));
        const columns: HTMLTableCellElement[][] = Array.from({ length: maxColumns }, () => []);

        rows.forEach((row) => {
          Array.from(row.children).forEach((td, index) => {
            if (columns[index]) {
              columns[index].push(td.cloneNode(true) as HTMLTableCellElement);
            }
          });
        });

        columns.forEach((cells, i) => {
          const columnDiv = document.createElement('div');
          columnDiv.className = 'column-group column-' + (i + 1);
          cells.forEach((cell) => columnDiv.appendChild(cell));
          newTable.appendChild(columnDiv);
        });

        table.remove();
      });
      answer.appendChild(newTable);
    }
  }

  function onDocumentReady() {
    dataLayerEnabled = document.body.hasAttribute('data-cmp-data-layer-enabled');
    if (dataLayerEnabled) {
      dataLayerName = document.body.getAttribute('data-cmp-data-layer-name') ?? 'adobeDataLayer';
      window[dataLayerName] = window[dataLayerName] || [];
    }

    const cfFaqs = document.querySelectorAll(`.${selectors.self}--${selectors.faq}`);

    cfFaqs.forEach((cfFaq) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _cfFaqObject = new ContentFragmentFAQ(cfFaq as HTMLElement);
    });

    const MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodesArray = Array.from(mutation.addedNodes) as HTMLElement[];

        if (nodesArray.length > 0) {
          nodesArray.forEach(function (addedNode) {
            if (addedNode instanceof HTMLElement) {
              const elementsArray = Array.from(
                addedNode.querySelectorAll(`.${selectors.self}--${selectors.faq}`)
              );
              elementsArray.forEach(function (element) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _cfFaqObject = new ContentFragmentFAQ(element as HTMLElement);
              });
            }
          });
        }
      });

      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  } else {
    onDocumentReady();
  }
})();
